import { render } from "./dpw-details.vue?vue&type=template&id=181cdae0&scoped=true"
import script from "./dpw-details.vue?vue&type=script&lang=js"
export * from "./dpw-details.vue?vue&type=script&lang=js"

import "./dpw-details.vue?vue&type=style&index=0&id=181cdae0&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181cdae0"]])

export default __exports__